<template>
    <kayit title="Şirket Tanıtımı" 
    v-on:kayitgetir="kayitgetir" 
    v-on:edititem="edititem"
    v-on:insertitem="insertitem"
    v-on:deleteitem="deleteitem"

    :tableheaders="headers" 
    :tableitems="items" 
    :item="item"
    :status="status" 
    > 
        <template slot-scope="props">
                  
                  <!-- <td>{{ props.item["SirketNo"]}}</td>
                  <td>{{ props.item["SirketIsmi"]}}</td>  -->

        </template>

        <template slot="dialogmain" slot-scope="prop" >
         <v-text-field hide-details label="SirketIsimi"   v-model="prop.item.SirketIsmi"></v-text-field>
         <v-text-field hide-details label="SirketKod"     v-model="prop.item.SirketKod"></v-text-field>
         <v-text-field hide-details label="SirketTelefon" v-model="prop.item.SirketTelefon"></v-text-field>
         <v-select     hide-details label="CariSirket"    v-model="prop.item.CariSirket" :items="cariSirketList"></v-select>


        </template>
          
        
    </kayit>
</template>

<script>
import kayit from "@/components/app/coper/comp/kayit.vue";
import tool from "../../tools";
//import rez from "../../rezervasyon";

export default {
  components: {
    kayit
  },
  data() {
    return {
      status:tool.NewSatatus(),
      headers: [
        { text: "SirketNo", value: "SirketNo" },
        { text: "SirketKod", value: "SirketKod" },
        { text: "SirketIsmi", value: "SirketIsmi" },
        { text: "CariSirket", value: "CariSirket" },
        { text: "SirketTelefon", value: "SirketTelefon" },
        { text: "İşlem", value: "islemsutunu", sortable: false }
      ],

      items: [],
      item: {
        SirketKod: "",
        SirketIsmi: "",
        SirketTelefon: "",
        CariSirket: ""
      },
      cariSirketList:[],

    };
  },
  methods: {
    kayitgetir: kayitgetir,
    kayitupdate: kayitupdate,
    kayitInsert:kayitInsert,
    edititem: edititem,
    insertitem: insertitem,
    deleteitem: deleteitem,
    cariSirketGetir:cariSirketGetir,
  },
  beforeMount:beforeMount,
  
};

function beforeMount() {
  this.cariSirketGetir();   
}

function edititem(val) {
  var i = this.items.findIndex(k => k.Ref == val.Ref);
  Object.assign(this.items[i], val);
  this.kayitupdate(val);
}

function insertitem(val) {
  this.kayitInsert(val);
}

function deleteitem(val) {

  val.Deleted="E";
  val.DeletedDate=tool.Now_yyyy_MM_dd();
  this.kayitupdate(val);
  const index = this.items.indexOf(val);
  this.items.splice(index, 1);
  
}

function kayitgetir(val) {
  
  this.status.loading = true;
  tool.http_post(this, "SirketList", {q : val}).then(
    response => {
      this.items = response.body;
      this.status.loading = false;
      //this.status.show = true;
      //this.status.text = "Kayıt getirildi";

    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function cariSirketGetir() {

  //if (this.cariSirketList.length==0)
  {

  this.status.loading = true;
  tool.http_post(this, "CariSirketList", null).then(
    response => {
      this.cariSirketList = response.body;
      this.status.loading = false;
      //this.status.show = true;
      //this.status.text = "";

    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
  }
}


function kayitupdate(val) {
  this.status.loading = true;
  tool.http_post(this, "SirketUpdate", val).then(
    response => {
      this.status.loading = false;
      //this.status.text = "";
      //this.status.show = true;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function kayitInsert(val) {
  this.status.loading = true;
  tool.http_post(this, "SirketInsert", val).then(
    response => {
      val=response.body;
      this.items.push(val);
      this.status.loading = false;
      //this.status.text = "Kaydedildi";
      //this.status.show = true;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}


</script>